// import React, { useEffect, useMemo, useState } from "react";
// import { Alert, Badge, Button, Card, Col, Form, Row, Spinner, Table } from "react-bootstrap";
// import { addDoc, collection, doc, getDocs, runTransaction, serverTimestamp, writeBatch,  } from "firebase/firestore";
// import * as XLSX from "xlsx";
// import { db } from "../../firebase";
// import { calculateAutoAmount, cleanObject, fmt } from "../../utils/eventUtils";
// import { createFundWithReceiptNumber } from "../../utils/receiptNumberUtils";

// const PAYMENT_METHODS = ["Cash", "PhonePe", "Google Pay", "UPI", "Bank Transfer"];

// const generateReceiptNumber = () => {
//   const now = new Date();

//   const year =
//     now.getFullYear();

//   const month =
//     String(
//       now.getMonth() + 1
//     ).padStart(2, "0");

//   const day =
//     String(
//       now.getDate()
//     ).padStart(2, "0");

//   const random =
//     Math.floor(
//       1000 +
//       Math.random() * 9000
//     );

//   return `RCPT-${year}${month}${day}-${random}`;
// };


// const extractFloor = (label) => {
//   const text = String(label || "").toUpperCase();
//   if (text.includes("-G") || text.startsWith("G")) return 0;
//   const numbers = text.match(/\d+/g);
//   if (!numbers?.length) return null;
//   const first = Number(numbers[0]);
//   return Number.isFinite(first) ? (first >= 100 ? Math.floor(first / 100) : first) : null;
// };

// const getAge = (value) => {
//   if (value == null) return null;
//   if (typeof value === "number" && Number.isFinite(value)) return value >= 0 ? value : null;
//   try {
//     const date = typeof value?.toDate === "function" ? value.toDate() : value instanceof Date ? value : typeof value === "string" ? new Date(value) : null;
//     if (!date || Number.isNaN(date.getTime())) return null;
//     const today = new Date();
//     let age = today.getFullYear() - date.getFullYear();
//     const monthDifference = today.getMonth() - date.getMonth();
//     if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < date.getDate())) age -= 1;
//     return age >= 0 ? age : null;
//   } catch {
//     return null;
//   }
// };

// const buildHousehold = (residents, blockName, flatLabel) => {
//   const members = [];
//   const seen = new Set();
//   residents
//     .filter((resident) => String(resident?.unit?.blockName || "").trim() === blockName && String(resident?.unit?.flatLabel || "").trim() === flatLabel)
//     .forEach((resident, residentIndex) => {
//       const name = resident.fullName || resident.displayName || resident.name || `Resident ${residentIndex + 1}`;
//       const residentKey = `resident:${resident.uid || resident.id || name}`;
//       if (!seen.has(residentKey)) {
//         seen.add(residentKey);
//         members.push({ id: resident.uid || resident.id || residentKey, name, age: getAge(resident.age ?? resident.dob), relationship: "Resident", isResident: true });
//       }
//       (Array.isArray(resident.family) ? resident.family : []).forEach((member, index) => {
//         const memberName = member?.name || `Family ${index + 1}`;
//         const memberKey = `family:${member?.id || memberName}:${index}`;
//         if (!seen.has(memberKey)) {
//           seen.add(memberKey);
//           members.push({ id: member?.id || memberKey, name: memberName, age: getAge(member?.age ?? member?.dob), relationship: member?.relationship || "Family", isResident: false });
//         }
//       });
//     });
//   return members;
// };

// const countHousehold = (members, freeAge) => members.reduce((counts, member) => {
//   if (member.isResident || (member.age != null && member.age >= 18)) counts.adults += 1;
//   else if (member.age != null) {
//     counts.kids += 1;
//     if (freeAge != null && member.age < freeAge) counts.freeKids += 1;
//   }
//   return counts;
// }, { adults: 0, kids: 0, freeKids: 0 });

// export default function FundContribution({ communityId, event, community, residents = [], canEditFunds, committeeOptions = [], onSaved, onClose }) {
//   const eventId = event?.id;
//   const entryFee = event?.entryFee || {};
//   const adultFee = Number(entryFee.adult) || 0;
//   const childFee = Number(entryFee.child) || 0;
//   const familyFee = Number(entryFee.familyFee) || 0;
//   const freeAge = entryFee.freeBelowAge == null ? null : Number(entryFee.freeBelowAge);
//   const isFamilyMode = event?.collectionMode === "family";

//   // const initialForm = useMemo(() => ({ blockName: "", floorNumber: "", flatLabel: "", amountMode: isFamilyMode ? "manual" : "auto", amount: isFamilyMode && familyFee > 0 ? String(familyFee) : "", receiptNo: "", method: "", receivedByUid: "", receivedByName: "" }), [familyFee, isFamilyMode]);
//   const initialForm = useMemo(
//   () => ({
//     blockName: "",
//     floorNumber: "",
//     flatLabel: "",

//     residentSelection: "",
//     payerUid: "",
//     paidByName: "",

//     amountMode: isFamilyMode ? "manual" : "auto",
//     amount:
//       isFamilyMode && familyFee > 0
//         ? String(familyFee)
//         : "",

//     receiptNo: generateReceiptNumber(),
//     method: "",
//     receivedByUid: "",
//     receivedByName: "",
//   }),
//   [familyFee, isFamilyMode]
// );
//   const [form, setForm] = useState(initialForm);
//   const [counts, setCounts] = useState({ adults: 0, kids: 0, freeKids: 0 });
//   const [members, setMembers] = useState([]);
//   const [showFamily, setShowFamily] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => setForm(initialForm), [initialForm]);

//   const blockOptions = useMemo(() => {
//     const values = new Set();
//     (Array.isArray(community?.blocks) ? community.blocks : []).forEach((block, index) => values.add(String(block?.name || block?.blockName || `Block-${index + 1}`).trim()));
//     residents.forEach((resident) => { const value = String(resident?.unit?.blockName || "").trim(); if (value) values.add(value); });
//     return [...values].filter(Boolean).sort();
//   }, [community, residents]);

//   const floorOptions = useMemo(() => {
//     if (!form.blockName) return [];
//     const values = new Set();
//     const blocks = Array.isArray(community?.blocks) ? community.blocks : [];
//     const block = blocks.find((item, index) => String(item?.name || item?.blockName || `Block-${index + 1}`).trim() === form.blockName);
//     if (block?.hasGround) values.add("0");
//     for (let floor = 1; floor <= Number(block?.floors || 0); floor += 1) values.add(String(floor));
//     (Array.isArray(block?.flats) ? block.flats : []).forEach((flat) => { const floor = extractFloor(flat); if (floor != null) values.add(String(floor)); });
//     residents.forEach((resident) => {
//       if (String(resident?.unit?.blockName || "").trim() !== form.blockName) return;
//       const suppliedFloor = resident?.unit?.floorNumber;
//       const floor = suppliedFloor !== "" && suppliedFloor != null ? Number(suppliedFloor) : extractFloor(resident?.unit?.flatLabel);
//       if (Number.isFinite(floor)) values.add(String(floor));
//     });
//     return [...values].sort((a, b) => Number(a) - Number(b)).map((value) => ({ value, label: value === "0" ? "Ground Floor" : `Floor ${value}` }));
//   }, [community, form.blockName, residents]);

//   const flatOptions = useMemo(() => {
//     if (!form.blockName || form.floorNumber === "") return [];
//     const values = new Set();
//     const blocks = Array.isArray(community?.blocks) ? community.blocks : [];
//     const block = blocks.find((item, index) => String(item?.name || item?.blockName || `Block-${index + 1}`).trim() === form.blockName);
//     (Array.isArray(block?.flats) ? block.flats : []).forEach((flat) => { if (String(extractFloor(flat) ?? "") === String(form.floorNumber)) values.add(String(flat).trim()); });
//     residents.forEach((resident) => {
//       if (String(resident?.unit?.blockName || "").trim() !== form.blockName) return;
//       const flat = String(resident?.unit?.flatLabel || "").trim();
//       const floor = resident?.unit?.floorNumber !== "" && resident?.unit?.floorNumber != null ? String(resident.unit.floorNumber) : String(extractFloor(flat) ?? "");
//       if (floor === String(form.floorNumber) && flat) values.add(flat);
//     });
//     return [...values].sort().map((value) => ({ value, label: value }));
//   }, [community, form.blockName, form.floorNumber, residents]);

//   const selectedFlatResidents = useMemo(() => {
//   const selectedBlock = String(
//     form.blockName || ""
//   ).trim();

//   const selectedFloor = String(
//     form.floorNumber ?? ""
//   ).trim();

//   const selectedFlat = String(
//     form.flatLabel || ""
//   ).trim();

//   if (
//     !selectedBlock ||
//     selectedFloor === "" ||
//     !selectedFlat
//   ) {
//     return [];
//   }

//   const matchingResidents = residents.filter(
//     (resident) => {
//       const residentBlock = String(
//         resident?.unit?.blockName ||
//           resident?.blockName ||
//           ""
//       ).trim();

//       const residentFlat = String(
//         resident?.unit?.flatLabel ||
//           resident?.flatLabel ||
//           ""
//       ).trim();

//       const configuredFloor =
//         resident?.unit?.floorNumber ??
//         resident?.floorNumber;

//       const residentFloor =
//         configuredFloor !== undefined &&
//         configuredFloor !== null &&
//         String(configuredFloor).trim() !== ""
//           ? String(configuredFloor).trim()
//           : String(
//               extractFloor(residentFlat) ?? ""
//             );

//       return (
//         residentBlock === selectedBlock &&
//         residentFlat === selectedFlat &&
//         residentFloor === selectedFloor
//       );
//     }
//   );

//   const uniqueResidents = new Map();

//   matchingResidents.forEach(
//     (resident, index) => {
//       const uid = String(
//         resident?.uid ||
//           resident?.id ||
//           ""
//       ).trim();

//       const name = String(
//         resident?.fullName ||
//           resident?.displayName ||
//           resident?.name ||
//           `Resident ${index + 1}`
//       ).trim();

//       const value = uid
//         ? `resident:${uid}`
//         : `resident-name:${name}`;

//       if (!uniqueResidents.has(value)) {
//         uniqueResidents.set(value, {
//           value,
//           uid,
//           name,
//         });
//       }
//     }
//   );

//   return Array.from(
//     uniqueResidents.values()
//   ).sort((first, second) =>
//     first.name.localeCompare(
//       second.name,
//       undefined,
//       {
//         sensitivity: "base",
//       }
//     )
//   );
// }, [
//   form.blockName,
//   form.floorNumber,
//   form.flatLabel,
//   residents,
// ]);

// const handleResidentSelectionChange = (
//   eventValue
// ) => {
//   const selectedValue =
//     eventValue.target.value;

//   if (!selectedValue) {
//     setForm((previous) => ({
//       ...previous,
//       residentSelection: "",
//       payerUid: "",
//       paidByName: "",
//     }));

//     return;
//   }

//   if (selectedValue === "other") {
//     setForm((previous) => ({
//       ...previous,
//       residentSelection: "other",
//       payerUid: "",
//       paidByName: "",
//     }));

//     return;
//   }

//   const selectedResident =
//     selectedFlatResidents.find(
//       (resident) =>
//         resident.value === selectedValue
//     );

//   if (!selectedResident) {
//     setForm((previous) => ({
//       ...previous,
//       residentSelection: "",
//       payerUid: "",
//       paidByName: "",
//     }));

//     return;
//   }

//   setForm((previous) => ({
//     ...previous,
//     residentSelection:
//       selectedResident.value,
//     payerUid:
//       selectedResident.uid || "",
//     paidByName:
//       selectedResident.name || "",
//   }));
// };

//   useEffect(() => {
//     if (!form.blockName || !form.flatLabel) {
//       setMembers([]);
//       setCounts({ adults: 0, kids: 0, freeKids: 0 });
//       return;
//     }
//     const household = buildHousehold(residents, form.blockName, form.flatLabel);
//     setMembers(household);
//     setCounts(countHousehold(household, freeAge));
//   }, [form.blockName, form.flatLabel, freeAge, residents]);

//   const autoAmount = useMemo(() => isFamilyMode ? familyFee : calculateAutoAmount({ adultFee, childFee, adults: counts.adults, kids: counts.kids, freeKids: counts.freeKids }), [adultFee, childFee, counts, familyFee, isFamilyMode]);

//   useEffect(() => {
//     if (form.amountMode === "auto" && !isFamilyMode) setForm((previous) => ({ ...previous, amount: autoAmount > 0 ? String(autoAmount) : "" }));
//   }, [autoAmount, form.amountMode, isFamilyMode]);

//   const updateCount = (key, value) => setCounts((previous) => {
//     const next = Math.max(0, Number(value) || 0);
//     if (key === "freeKids") return { ...previous, freeKids: Math.min(next, previous.kids) };
//     if (key === "kids") return { ...previous, kids: next, freeKids: Math.min(previous.freeKids, next) };
//     return { ...previous, [key]: next };
//   });

// //   const save = async () => {
// //     if (!canEditFunds || !eventId) return alert("Not allowed or event is missing.");
// //     // if (!form.blockName || form.floorNumber === "" || !form.flatLabel) return alert("Select block, floor and flat.");
// //     if (!form.residentSelection) {
// //   return alert(
// //     "Select a resident or Other Name."
// //   );
// // }

// // if (
// //   form.residentSelection === "other" &&
// //   !String(form.paidByName || "").trim()
// // ) {
// //   return alert(
// //     "Enter the resident name."
// //   );
// // }

// // if (
// //   form.residentSelection !== "other" &&
// //   !String(form.paidByName || "").trim()
// // ) {
// //   return alert(
// //     "The selected resident name is missing."
// //   );
// // }
    
// //     if (!form.method || (!form.receivedByUid && !form.receivedByName)) return alert("Select pay mode and received by.");
// //     const amount = form.amountMode === "manual" || isFamilyMode ? Number(form.amount) : autoAmount;
// //     if (!Number.isFinite(amount) || amount <= 0) return alert("Amount must be greater than 0. Enter household counts manually if resident family data is missing.");
// //     try {
// //       setSaving(true);
// //       await addDoc(collection(db, "events", eventId, "funds"), cleanObject({ sourceType: "resident", payerType: "resident", communityId: String(communityId || ""), eventId, blockName: form.blockName.trim(), floorNumber: Number(form.floorNumber), flatLabel: form.flatLabel.trim(), amount, receiptNo: form.receiptNo.trim(), method: form.method, receivedByUid: form.receivedByUid || undefined, receivedByName: form.receivedByName, amountMode: form.amountMode, householdCounts: counts, entryFeeUsed: { adult: adultFee, child: childFee, familyFee, freeBelowAge: freeAge }, createdAt: serverTimestamp() }));
// //       setForm(initialForm);
// //       setCounts({ adults: 0, kids: 0, freeKids: 0 });
// //       setMembers([]);
// //       setShowFamily(false);
// //       onSaved?.();
// //       onClose?.();
// //     } catch (error) {
// //       alert(error?.message || "Failed to add contribution.");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// const save = async () => {
//   if (!canEditFunds) {
//     alert(
//       "You are not allowed to add funds."
//     );
//     return;
//   }

//   if (!eventId) {
//     alert("Event ID is missing.");
//     return;
//   }

//   if (
//     !form.blockName ||
//     form.floorNumber === "" ||
//     !form.flatLabel
//   ) {
//     alert(
//       "Select block, floor and flat."
//     );
//     return;
//   }

//   if (!form.residentSelection) {
//     alert(
//       "Select a resident or Other Name."
//     );
//     return;
//   }

//   if (
//     !String(form.paidByName || "").trim()
//   ) {
//     alert("Enter or select resident name.");
//     return;
//   }

//   if (!form.method) {
//     alert("Select pay mode.");
//     return;
//   }

//   if (
//     !form.receivedByUid &&
//     !form.receivedByName
//   ) {
//     alert("Select received by.");
//     return;
//   }

//   const amount =
//     form.amountMode === "manual" ||
//     isFamilyMode
//       ? Number(form.amount)
//       : autoAmount;

//   if (
//     !Number.isFinite(amount) ||
//     amount <= 0
//   ) {
//     alert(
//       "Amount must be greater than 0. Enter household counts manually if resident family data is missing."
//     );

//     return;
//   }

//   try {
//     setSaving(true);

//     // await addDoc(
//     //   collection(
//     //     db,
//     //     "events",
//     //     eventId,
//     //     "funds"
//     //   ),
//     //   cleanObject({
//     //     sourceType: "resident",
//     //     payerType: "resident",

//     //     communityId: String(
//     //       communityId || ""
//     //     ),

//     //     eventId,

//     //     blockName:
//     //       form.blockName.trim(),

//     //     floorNumber: Number(
//     //       form.floorNumber
//     //     ),

//     //     flatLabel:
//     //       form.flatLabel.trim(),

//     //     residentSelection:
//     //       form.residentSelection,

//     //     payerUid:
//     //       form.residentSelection ===
//     //       "other"
//     //         ? undefined
//     //         : form.payerUid ||
//     //           undefined,

//     //     paidByName: String(
//     //       form.paidByName || ""
//     //     ).trim(),

//     //     amount,

//     //     receiptNo: String(
//     //       form.receiptNo || ""
//     //     ).trim(),

//     //     method: form.method,

//     //     receivedByUid:
//     //       form.receivedByUid ||
//     //       undefined,

//     //     receivedByName:
//     //       form.receivedByName,

//     //     amountMode:
//     //       form.amountMode,

//     //     householdCounts: {
//     //       adults:
//     //         Number(counts.adults) || 0,

//     //       kids:
//     //         Number(counts.kids) || 0,

//     //       freeKids:
//     //         Number(counts.freeKids) || 0,
//     //     },

//     //     entryFeeUsed: {
//     //       adult: adultFee,
//     //       child: childFee,
//     //       familyFee,
//     //       freeBelowAge: freeAge,
//     //     },

//     //     createdAt:
//     //       serverTimestamp(),
//     //   })
//     // );

//     const contributionPayload =
//   cleanObject({
//     sourceType: "resident",
//     payerType: "resident",

//     communityId: String(
//       communityId || ""
//     ),

//     eventId,

//     blockName:
//       form.blockName.trim(),

//     floorNumber: Number(
//       form.floorNumber
//     ),

//     flatLabel:
//       form.flatLabel.trim(),

//     residentSelection:
//       form.residentSelection,

//     payerUid:
//       form.residentSelection ===
//       "other"
//         ? undefined
//         : form.payerUid ||
//           undefined,

//     paidByName: String(
//       form.paidByName || ""
//     ).trim(),

//     amount,

//     method: form.method,

//     receivedByUid:
//       form.receivedByUid ||
//       undefined,

//     receivedByName:
//       form.receivedByName,

//     amountMode:
//       form.amountMode,

//     householdCounts: {
//       adults:
//         Number(counts.adults) || 0,

//       kids:
//         Number(counts.kids) || 0,

//       freeKids:
//         Number(counts.freeKids) || 0,
//     },

//     entryFeeUsed: {
//       adult: adultFee,
//       child: childFee,
//       familyFee,
//       freeBelowAge: freeAge,
//     },
//   });

// const savedContribution =
//   await createFundWithReceiptNumber({
//     db,
//     eventId,
//     payload: contributionPayload,
//   });

// alert(
//   `Contribution saved successfully. Receipt Number: ${savedContribution.receiptNo}`
// );
//     setForm(initialForm);

//     setCounts({
//       adults: 0,
//       kids: 0,
//       freeKids: 0,
//     });

//     setMembers([]);
//     setShowFamily(false);

//     onSaved?.();
//     onClose?.();
//   } catch (error) {
//   console.error("FULL ERROR:", error);

//   alert(
//     error?.code +
//     " - " +
//     error?.message
//   )

//     alert(
//       error?.message ||
//         "Failed to add contribution."
//     );
//   } finally {
//     setSaving(false);
//   }
// };
//   const downloadTemplate = () => {
//     const rows = [{ blockName: "A", flatLabel: "A-101", paidByName: "Resident Name", adults: 2, kids: 1, freeKids: 0, amountMode: isFamilyMode ? "manual" : "auto", amount: isFamilyMode ? familyFee : "", receiptNo: "RCPT-001", method: "Cash", receivedByUid: "", receivedByName: "Committee Member" }];
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), "Residents");
//     XLSX.writeFile(workbook, `ResidentFundsTemplate_${String(event?.name || "Event").replace(/[\\/:*?"<>|]/g, "_")}.xlsx`);
//   };

//   const uploadTemplate = async (file) => {
//     if (!file || !canEditFunds || !eventId) return;
//     try {
//       setUploading(true);
//       const workbook = XLSX.read(await file.arrayBuffer(), { type: "array" });
//       const sheet = workbook.Sheets.Residents || workbook.Sheets[workbook.SheetNames[0]];
//       const rows = sheet ? XLSX.utils.sheet_to_json(sheet, { defval: "" }) : [];
//       const payloads = rows.map((row) => {
//         const amountMode = String(row.amountMode || (isFamilyMode ? "manual" : "auto")).toLowerCase() === "manual" ? "manual" : "auto";
//         const rowCounts = { adults: Math.max(0, Number(row.adults) || 0), kids: Math.max(0, Number(row.kids) || 0), freeKids: Math.max(0, Number(row.freeKids) || 0) };
//         rowCounts.freeKids = Math.min(rowCounts.freeKids, rowCounts.kids);
//         const amount = isFamilyMode || amountMode === "manual" ? Number(row.amount || familyFee) : calculateAutoAmount({ adultFee, childFee, ...rowCounts });
//         if (!row.blockName || !row.flatLabel || !Number.isFinite(amount) || amount <= 0) return null;
//         return cleanObject({ sourceType: "resident", payerType: "resident", communityId: String(communityId || ""), eventId, blockName: String(row.blockName).trim(), floorNumber: extractFloor(row.flatLabel), flatLabel: String(row.flatLabel).trim(), paidByName: String(row.paidByName || "").trim() || undefined, amount, receiptNo: String(row.receiptNo || "").trim(), method: String(row.method || "").trim(), receivedByUid: String(row.receivedByUid || "").trim() || undefined, receivedByName: String(row.receivedByName || "").trim() || undefined, amountMode, householdCounts: rowCounts, entryFeeUsed: { adult: adultFee, child: childFee, familyFee, freeBelowAge: freeAge }, createdAt: serverTimestamp() });
//       }).filter(Boolean);
//       for (let start = 0; start < payloads.length; start += 450) {
//         const batch = writeBatch(db);
//         payloads.slice(start, start + 450).forEach((payload) => batch.set(doc(collection(db, "events", eventId, "funds")), payload));
//         await batch.commit();
//       }
//       alert(`Uploaded: ${payloads.length}. Skipped: ${rows.length - payloads.length}.`);
//     } catch (error) {
//       alert(error?.message || "Failed to upload contributions.");
//     } finally {
//       setUploading(false);
//     }
//   };

  
  

//   return <div>
//    <Row className="g-3">
//   <Col md={3}>
//     <Form.Label>Block</Form.Label>

//     <Form.Select
//       value={form.blockName}
//       onChange={(eventValue) =>
//         setForm((previous) => ({
//           ...previous,
//           blockName:
//             eventValue.target.value,
//           floorNumber: "",
//           flatLabel: "",
//           residentSelection: "",
//           payerUid: "",
//           paidByName: "",
//         }))
//       }
//     >
//       <option value="">
//         Select Block
//       </option>

//       {blockOptions.map((value) => (
//         <option
//           key={value}
//           value={value}
//         >
//           {value}
//         </option>
//       ))}
//     </Form.Select>
//   </Col>

//   <Col md={3}>
//     <Form.Label>Floor</Form.Label>

//     <Form.Select
//       value={form.floorNumber}
//       disabled={!form.blockName}
//       onChange={(eventValue) =>
//         setForm((previous) => ({
//           ...previous,
//           floorNumber:
//             eventValue.target.value,
//           flatLabel: "",
//           residentSelection: "",
//           payerUid: "",
//           paidByName: "",
//         }))
//       }
//     >
//       <option value="">
//         Select Floor
//       </option>

//       {floorOptions.map((option) => (
//         <option
//           key={option.value}
//           value={option.value}
//         >
//           {option.label}
//         </option>
//       ))}
//     </Form.Select>
//   </Col>

//   <Col md={3}>
//     <Form.Label>Flat</Form.Label>

//     <Form.Select
//       value={form.flatLabel}
//       disabled={
//         form.floorNumber === ""
//       }
//       onChange={(eventValue) =>
//         setForm((previous) => ({
//           ...previous,
//           flatLabel:
//             eventValue.target.value,
//           residentSelection: "",
//           payerUid: "",
//           paidByName: "",
//         }))
//       }
//     >
//       <option value="">
//         Select Flat
//       </option>

//       {flatOptions.map((option) => (
//         <option
//           key={option.value}
//           value={option.value}
//         >
//           {option.label}
//         </option>
//       ))}
//     </Form.Select>
//   </Col>

//   <Col md={3}>
//     <Form.Label>
//       Resident Name
//     </Form.Label>

//     <Form.Select
//       value={
//         form.residentSelection || ""
//       }
//       disabled={!form.flatLabel}
//       onChange={
//         handleResidentSelectionChange
//       }
//     >
//       <option value="">
//         {form.flatLabel
//           ? "Select Resident"
//           : "Select Flat First"}
//       </option>

//       {selectedFlatResidents.map(
//         (resident) => (
//           <option
//             key={resident.value}
//             value={resident.value}
//           >
//             {resident.name}
//           </option>
//         )
//       )}

//       <option value="other">
//         Other Name
//       </option>
//     </Form.Select>

//     {/* {form.flatLabel &&
//       selectedFlatResidents.length ===
//         0 && (
//         <Form.Text className="text-muted">
//           No registered resident was found.
//           Select Other Name to enter the
//           resident name manually.
//         </Form.Text>
//       )} */}
//   </Col>
// </Row>

// {form.residentSelection === "other" && (
//   <Row className="g-3 mt-1">
//     <Col md={4}>
//       <Form.Label>
//         Enter Resident Name
//       </Form.Label>

//       <Form.Control
//         type="text"
//         value={form.paidByName}
//         placeholder="Enter resident name"
//         onChange={(eventValue) =>
//           setForm((previous) => ({
//             ...previous,
//             payerUid: "",
//             paidByName:
//               eventValue.target.value,
//           }))
//         }
//       />
//     </Col>
//   </Row>
// )}

//     {!isFamilyMode && <Card className="mt-3"><Card.Body>
//       {/* {members.length === 0 && form.flatLabel && <Alert variant="warning">Resident family data was not found. Enter Adults, Kids and Free Kids manually. The amount will still calculate automatically.</Alert>} */}
//       <Row className="g-3">
//         <Col md={4}><Form.Label>Adults</Form.Label><Form.Control type="number" min="0" value={counts.adults} onChange={(e) => updateCount("adults", e.target.value)} /></Col>
//         <Col md={4}><Form.Label>Kids</Form.Label><Form.Control type="number" min="0" value={counts.kids} onChange={(e) => updateCount("kids", e.target.value)} /></Col>
//         <Col md={4}><Form.Label>Free Kids {freeAge != null ? `(below ${freeAge})` : ""}</Form.Label><Form.Control type="number" min="0" max={counts.kids} value={counts.freeKids} onChange={(e) => updateCount("freeKids", e.target.value)} /></Col>
//       </Row>
//       <div className="mt-3">Adults: {counts.adults} x Rs. {fmt(adultFee)} | Chargeable Kids: {Math.max(0, counts.kids - counts.freeKids)} x Rs. {fmt(childFee)} | <Badge bg="primary">Total: Rs. {fmt(autoAmount)}</Badge></div>
//       {members.length > 0 && <Button type="button" variant="link" className="px-0" onClick={() => setShowFamily((value) => !value)}>{showFamily ? "Hide" : "Show"} family details</Button>}
//       {showFamily && members.length > 0 && <Table bordered responsive size="sm"><thead><tr><th>Name</th><th>Age</th><th>Relationship</th></tr></thead><tbody>{members.map((member) => <tr key={member.id}><td>{member.name}</td><td>{member.age ?? "-"}</td><td>{member.relationship}</td></tr>)}</tbody></Table>}
//     </Card.Body></Card>}

//     <Row className="g-3 mt-1">
//       <Col md={3}><Form.Label>Amount Mode</Form.Label><div><Form.Check inline type="radio" label="Auto" disabled={isFamilyMode} checked={form.amountMode === "auto"} onChange={() => setForm((p) => ({ ...p, amountMode: "auto" }))} /><Form.Check inline type="radio" label="Manual" checked={form.amountMode === "manual"} onChange={() => setForm((p) => ({ ...p, amountMode: "manual" }))} /></div></Col>
//       <Col md={3}><Form.Label>Amount</Form.Label><Form.Control type="number" min="0" value={form.amount} disabled={form.amountMode === "auto" && !isFamilyMode} onChange={(e) => setForm((p) => ({ ...p, amount: e.target.value }))} /></Col>
//       <Col md={3}><Form.Label>Receipt No</Form.Label><Form.Control value={form.receiptNo} onChange={(e) => setForm((p) => ({ ...p, receiptNo: e.target.value }))} /></Col>
//       <Col md={3}><Form.Label>Pay Mode</Form.Label><Form.Select value={form.method} onChange={(e) => setForm((p) => ({ ...p, method: e.target.value }))}><option value="">Select Pay Mode</option>{PAYMENT_METHODS.map((method) => <option key={method} value={method}>{method}</option>)}</Form.Select></Col>
//       <Col md={4}><Form.Label>Received By</Form.Label><Form.Select value={form.receivedByUid ? `uid:${form.receivedByUid}` : form.receivedByName ? `name:${form.receivedByName}` : ""} onChange={(e) => { const option = committeeOptions.find((item) => item.value === e.target.value); setForm((p) => ({ ...p, receivedByUid: option?.uid || "", receivedByName: option?.label || "" })); }}><option value="">Select Committee Member</option>{committeeOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</Form.Select></Col>
//     </Row>

//     <div className="d-flex flex-wrap gap-2 mt-4"><Button type="button" onClick={save} disabled={saving}>{saving ? <><Spinner size="sm" className="me-2" />Saving...</> : "Add Contribution"}</Button><Button type="button" variant="outline-secondary" onClick={downloadTemplate}>Download Template</Button><Form.Label className={`btn btn-outline-success mb-0 ${uploading ? "disabled" : ""}`}>{uploading ? "Uploading..." : "Upload Excel"}<Form.Control hidden type="file" accept=".xlsx,.xls" disabled={uploading} onChange={async (e) => { await uploadTemplate(e.target.files?.[0]); e.target.value = ""; }} /></Form.Label></div>
//   </div>;
// }


import React, { useEffect, useMemo, useState, useCallback, } from "react";
import { Alert, Badge, Button, Card, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { addDoc, collection, doc, getDocs, serverTimestamp, writeBatch,  } from "firebase/firestore";
import * as XLSX from "xlsx";
import { db } from "../../firebase";
import { calculateAutoAmount, cleanObject, fmt } from "../../utils/eventUtils";

const PAYMENT_METHODS = ["Cash", "PhonePe", "Google Pay", "UPI", "Bank Transfer"];

const extractFloor = (label) => {
  const text = String(label || "").toUpperCase();
  if (text.includes("-G") || text.startsWith("G")) return 0;
  const numbers = text.match(/\d+/g);
  if (!numbers?.length) return null;
  const first = Number(numbers[0]);
  return Number.isFinite(first) ? (first >= 100 ? Math.floor(first / 100) : first) : null;
};

const getAge = (value) => {
  if (value == null) return null;
  if (typeof value === "number" && Number.isFinite(value)) return value >= 0 ? value : null;
  try {
    const date = typeof value?.toDate === "function" ? value.toDate() : value instanceof Date ? value : typeof value === "string" ? new Date(value) : null;
    if (!date || Number.isNaN(date.getTime())) return null;
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const monthDifference = today.getMonth() - date.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < date.getDate())) age -= 1;
    return age >= 0 ? age : null;
  } catch {
    return null;
  }
};

const buildHousehold = (residents, blockName, flatLabel) => {
  const members = [];
  const seen = new Set();
  (Array.isArray(residents) ? residents : [])
    .filter((resident) => String(resident?.unit?.blockName || "").trim() === blockName && String(resident?.unit?.flatLabel || "").trim() === flatLabel)
    .forEach((resident, residentIndex) => {
      const name = resident.fullName || resident.displayName || resident.name || `Resident ${residentIndex + 1}`;
      const residentKey = `resident:${resident.uid || resident.id || name}`;
      if (!seen.has(residentKey)) {
        seen.add(residentKey);
        members.push({ id: resident.uid || resident.id || residentKey, name, age: getAge(resident.age ?? resident.dob), relationship: "Resident", isResident: true });
      }
      (Array.isArray(resident.family) ? resident.family : []).forEach((member, index) => {
        const memberName = member?.name || `Family ${index + 1}`;
        const memberKey = `family:${member?.id || memberName}:${index}`;
        if (!seen.has(memberKey)) {
          seen.add(memberKey);
          members.push({ id: member?.id || memberKey, name: memberName, age: getAge(member?.age ?? member?.dob), relationship: member?.relationship || "Family", isResident: false });
        }
      });
    });
  return members;
};

const countHousehold = (members, freeAge) => members.reduce((counts, member) => {
  if (member.isResident || (member.age != null && member.age >= 18)) counts.adults += 1;
  else if (member.age != null) {
    counts.kids += 1;
    if (freeAge != null && member.age < freeAge) counts.freeKids += 1;
  }
  return counts;
}, { adults: 0, kids: 0, freeKids: 0 });

const currentYearMonthPrefix = () => {
  const date = new Date();
  const year = String(date.getFullYear()).slice(-2);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}${month}`;
};

const parseReceiptNumber = (value) => {
  const match = String(value || "").trim().match(/^(\d{4})(\d{4,})$/);
  if (!match) return null;
  const sequence = Number(match[2]);
  return Number.isFinite(sequence) ? { prefix: match[1], sequence } : null;
};

const getReceiptSeries = async (
  eventId
) => {
  const snapshot = await getDocs(
    collection(
      db,
      "events",
      eventId,
      "funds"
    )
  );

  let existingPrefix = null;

  let highestSequence = 0;

  snapshot.forEach(
    (documentSnapshot) => {
      const receiptNo =
        String(
          documentSnapshot.data()
            ?.receiptNo || ""
        ).trim();

      const match =
        receiptNo.match(
          /^(\d{4})(\d+)$/
        );

      if (!match) {
        return;
      }

      const prefix = match[1];

      const sequence =
        Number(match[2]) || 0;

      if (!existingPrefix) {
        existingPrefix = prefix;
      }

      if (
        sequence >
        highestSequence
      ) {
        highestSequence =
          sequence;
      }
    }
  );

  if (!existingPrefix) {
    existingPrefix =
      currentYearMonthPrefix();
  }

  return {
    prefix: existingPrefix,
    highestSequence,
  };
};

const buildReceiptNumber = (prefix, sequence) => `${prefix}${String(sequence).padStart(4, "0")}`;

const saveFundWithAutomaticReceipt = async (eventId, payload) => {
  const series = await getReceiptSeries(eventId);
  const sequence = series.highestSequence + 1;
  const receiptNo = buildReceiptNumber(series.prefix, sequence);
  const savedDocument = await addDoc(collection(db, "events", eventId, "funds"), {
    ...payload,
    receiptNo,
    receiptPrefix: series.prefix,
    receiptSequence: sequence,
    createdAt: serverTimestamp(),
  });
  return { id: savedDocument.id, receiptNo };
};

export default function FundContribution({ communityId, event, community, residents = [], canEditFunds, committeeOptions = [], onSaved, onClose }) {
  const eventId = event?.id;
  const entryFee = event?.entryFee || {};
  const adultFee = Number(entryFee.adult) || 0;
  const childFee = Number(entryFee.child) || 0;
  const familyFee = Number(entryFee.familyFee) || 0;
  const freeAge = entryFee.freeBelowAge == null ? null : Number(entryFee.freeBelowAge);
  const isFamilyMode = event?.collectionMode === "family";

  const initialForm = useMemo(() => ({
    blockName: "",
    floorNumber: "",
    flatLabel: "",
    residentSelection: "",
    payerUid: "",
    paidByName: "",
    amountMode: isFamilyMode ? "manual" : "auto",
    amount: isFamilyMode && familyFee > 0 ? String(familyFee) : "",
    receiptNo: "",
    method: "",
    receivedByUid: "",
    receivedByName: "",
  }), [familyFee, isFamilyMode]);

  const [form, setForm] = useState(initialForm);
  const [counts, setCounts] = useState({ adults: 0, kids: 0, freeKids: 0 });
  const [members, setMembers] = useState([]);
  const [showFamily, setShowFamily] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [
  loadingReceiptNumber,
  setLoadingReceiptNumber,
] = useState(false);

const [
  receiptError,
  setReceiptError,
] = useState("");

const getNextReceiptNumber =
  useCallback(async () => {
    if (!eventId) {
      return buildReceiptNumber(
        currentYearMonthPrefix(),
        1
      );
    }

    const receiptSeries =
      await getReceiptSeries(
        eventId
      );

    return buildReceiptNumber(
      receiptSeries.prefix,
      receiptSeries.highestSequence +
        1
    );
  }, [eventId]);

  const loadNextReceiptNumber =
  useCallback(async () => {
    if (!eventId) {
      setForm((previous) => ({
        ...previous,
        receiptNo: "",
      }));

      return;
    }

    try {
      setLoadingReceiptNumber(true);
      setReceiptError("");

      const nextReceiptNumber =
        await getNextReceiptNumber();

      setForm((previous) => ({
        ...previous,
        receiptNo:
          nextReceiptNumber,
      }));
    } catch (error) {
      console.error(
        "Load receipt number error:",
        error
      );

      setReceiptError(
        error?.message ||
          "Unable to load the next receipt number."
      );

      setForm((previous) => ({
        ...previous,
        receiptNo: "",
      }));
    } finally {
      setLoadingReceiptNumber(
        false
      );
    }
  }, [
    eventId,
    getNextReceiptNumber,
  ]);
  

//   useEffect(() => setForm(initialForm), [initialForm]);
useEffect(() => {
  setForm(initialForm);
}, [initialForm]);

useEffect(() => {
  loadNextReceiptNumber();
}, [loadNextReceiptNumber]);

  const blockOptions = useMemo(() => {
    const values = new Set();
    (Array.isArray(community?.blocks) ? community.blocks : []).forEach((block, index) => {
      const value = String(block?.name || block?.blockName || `Block-${index + 1}`).trim();
      if (value) values.add(value);
    });
    residents.forEach((resident) => {
      const value = String(resident?.unit?.blockName || "").trim();
      if (value) values.add(value);
    });
    return [...values].sort();
  }, [community, residents]);

  const floorOptions = useMemo(() => {
    if (!form.blockName) return [];
    const values = new Set();
    const blocks = Array.isArray(community?.blocks) ? community.blocks : [];
    const block = blocks.find((item, index) => String(item?.name || item?.blockName || `Block-${index + 1}`).trim() === form.blockName);
    if (block?.hasGround) values.add("0");
    for (let floor = 1; floor <= Number(block?.floors || 0); floor += 1) values.add(String(floor));
    (Array.isArray(block?.flats) ? block.flats : []).forEach((flat) => {
      const floor = extractFloor(flat);
      if (floor != null) values.add(String(floor));
    });
    residents.forEach((resident) => {
      if (String(resident?.unit?.blockName || "").trim() !== form.blockName) return;
      const supplied = resident?.unit?.floorNumber;
      const floor = supplied !== "" && supplied != null ? Number(supplied) : extractFloor(resident?.unit?.flatLabel);
      if (Number.isFinite(floor)) values.add(String(floor));
    });
    return [...values].sort((a, b) => Number(a) - Number(b)).map((value) => ({ value, label: value === "0" ? "Ground Floor" : `Floor ${value}` }));
  }, [community, form.blockName, residents]);

  const flatOptions = useMemo(() => {
    if (!form.blockName || form.floorNumber === "") return [];
    const values = new Set();
    const blocks = Array.isArray(community?.blocks) ? community.blocks : [];
    const block = blocks.find((item, index) => String(item?.name || item?.blockName || `Block-${index + 1}`).trim() === form.blockName);
    (Array.isArray(block?.flats) ? block.flats : []).forEach((flat) => {
      if (String(extractFloor(flat) ?? "") === String(form.floorNumber)) values.add(String(flat).trim());
    });
    residents.forEach((resident) => {
      if (String(resident?.unit?.blockName || "").trim() !== form.blockName) return;
      const flat = String(resident?.unit?.flatLabel || "").trim();
      const floor = resident?.unit?.floorNumber !== "" && resident?.unit?.floorNumber != null ? String(resident.unit.floorNumber) : String(extractFloor(flat) ?? "");
      if (floor === String(form.floorNumber) && flat) values.add(flat);
    });
    return [...values].sort().map((value) => ({ value, label: value }));
  }, [community, form.blockName, form.floorNumber, residents]);

  const selectedFlatResidents = useMemo(() => {
    if (!form.blockName || !form.flatLabel) return [];
    const unique = new Map();
    residents.filter((resident) => String(resident?.unit?.blockName || "").trim() === form.blockName && String(resident?.unit?.flatLabel || "").trim() === form.flatLabel).forEach((resident, index) => {
      const uid = String(resident?.uid || resident?.id || "").trim();
      const name = String(resident?.fullName || resident?.displayName || resident?.name || `Resident ${index + 1}`).trim();
      const value = uid ? `resident:${uid}` : `resident-name:${name}`;
      if (!unique.has(value)) unique.set(value, { value, uid, name });
    });
    return [...unique.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
  }, [form.blockName, form.flatLabel, residents]);

  useEffect(() => {
    if (!form.blockName || !form.flatLabel) {
      setMembers([]);
      setCounts({ adults: 0, kids: 0, freeKids: 0 });
      return;
    }
    const household = buildHousehold(residents, form.blockName, form.flatLabel);
    setMembers(household);
    setCounts(countHousehold(household, freeAge));
  }, [form.blockName, form.flatLabel, freeAge, residents]);

  const autoAmount = useMemo(() => isFamilyMode ? familyFee : calculateAutoAmount({ adultFee, childFee, adults: counts.adults, kids: counts.kids, freeKids: counts.freeKids }), [adultFee, childFee, counts, familyFee, isFamilyMode]);

  useEffect(() => {
    if (form.amountMode === "auto" && !isFamilyMode) setForm((previous) => ({ ...previous, amount: autoAmount > 0 ? String(autoAmount) : "" }));
  }, [autoAmount, form.amountMode, isFamilyMode]);

  const handleResidentSelectionChange = (eventValue) => {
    const value = eventValue.target.value;
    if (value === "other") {
      setForm((previous) => ({ ...previous, residentSelection: "other", payerUid: "", paidByName: "" }));
      return;
    }
    const resident = selectedFlatResidents.find((item) => item.value === value);
    setForm((previous) => ({ ...previous, residentSelection: resident?.value || "", payerUid: resident?.uid || "", paidByName: resident?.name || "" }));
  };

  const updateCount = (key, value) => setCounts((previous) => {
    const next = Math.max(0, Number(value) || 0);
    if (key === "freeKids") return { ...previous, freeKids: Math.min(next, previous.kids) };
    if (key === "kids") return { ...previous, kids: next, freeKids: Math.min(previous.freeKids, next) };
    return { ...previous, [key]: next };
  });

  const save = async () => {
    if (!canEditFunds) return alert("You are not allowed to add funds.");
    if (!eventId) return alert("Event ID is missing.");
    if (!form.blockName || form.floorNumber === "" || !form.flatLabel) return alert("Select block, floor and flat.");
    if (!form.residentSelection) return alert("Select a resident or Other Name.");
    if (!String(form.paidByName || "").trim()) return alert("Enter or select resident name.");
    if (!form.method) return alert("Select pay mode.");
    if (!form.receivedByUid && !form.receivedByName) return alert("Select received by.");

    const amount = form.amountMode === "manual" || isFamilyMode ? Number(form.amount) : autoAmount;
    if (!Number.isFinite(amount) || amount <= 0) return alert("Amount must be greater than 0. Enter household counts manually if resident family data is missing.");

    const payload = cleanObject({
      sourceType: "resident",
      payerType: "resident",
      communityId: String(communityId || ""),
      eventId,
      blockName: form.blockName.trim(),
      floorNumber: Number(form.floorNumber),
      flatLabel: form.flatLabel.trim(),
      residentSelection: form.residentSelection,
      payerUid: form.residentSelection === "other" ? undefined : form.payerUid || undefined,
      paidByName: String(form.paidByName || "").trim(),
      amount,
      method: form.method,
      receivedByUid: form.receivedByUid || undefined,
      receivedByName: form.receivedByName,
      amountMode: form.amountMode,
      householdCounts: { adults: Number(counts.adults) || 0, kids: Number(counts.kids) || 0, freeKids: Number(counts.freeKids) || 0 },
      entryFeeUsed: { adult: adultFee, child: childFee, familyFee, freeBelowAge: freeAge },
    });

    try {
      setSaving(true);
    //   const saved = await saveFundWithAutomaticReceipt(eventId, payload);
    //   alert(`Contribution saved successfully. Receipt Number: ${saved.receiptNo}`);
    //   setForm(initialForm);
    //   setCounts({ adults: 0, kids: 0, freeKids: 0 });
    //   setMembers([]);
    //   setShowFamily(false);
    //   onSaved?.(saved);
    //   onClose?.();

    const saved =
  await saveFundWithAutomaticReceipt(
    eventId,
    payload
  );

alert(
  `Contribution saved successfully. Receipt Number: ${saved.receiptNo}`
);

setCounts({
  adults: 0,
  kids: 0,
  freeKids: 0,
});

setMembers([]);
setShowFamily(false);

onSaved?.(saved);

if (onClose) {
  onClose();
} else {
  const nextReceiptNumber =
    await getNextReceiptNumber();

  setForm({
    ...initialForm,
    receiptNo:
      nextReceiptNumber,
  });
}
    } catch (error) {
      console.error("Add contribution error:", error);
      alert(error?.message || "Failed to add contribution.");
    } finally {
      setSaving(false);
    }
  };

  const downloadTemplate = () => {
    const rows = [{ blockName: "A", flatLabel: "A-101", paidByName: "Resident Name", adults: 2, kids: 1, freeKids: 0, amountMode: isFamilyMode ? "manual" : "auto", amount: isFamilyMode ? familyFee : "", method: "Cash", receivedByUid: "", receivedByName: "Committee Member" }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), "Residents");
    XLSX.writeFile(workbook, `ResidentFundsTemplate_${String(event?.name || "Event").replace(/[\\/:*?"<>|]/g, "_")}.xlsx`);
  };

  const uploadTemplate = async (file) => {
    if (!file || !canEditFunds || !eventId) return;
    try {
      setUploading(true);
      const workbook = XLSX.read(await file.arrayBuffer(), { type: "array" });
      const sheet = workbook.Sheets.Residents || workbook.Sheets[workbook.SheetNames[0]];
      const rows = sheet ? XLSX.utils.sheet_to_json(sheet, { defval: "" }) : [];
      const payloads = rows.map((row) => {
        const amountMode = String(row.amountMode || (isFamilyMode ? "manual" : "auto")).toLowerCase() === "manual" ? "manual" : "auto";
        const rowCounts = { adults: Math.max(0, Number(row.adults) || 0), kids: Math.max(0, Number(row.kids) || 0), freeKids: Math.max(0, Number(row.freeKids) || 0) };
        rowCounts.freeKids = Math.min(rowCounts.freeKids, rowCounts.kids);
        const amount = isFamilyMode || amountMode === "manual" ? Number(row.amount || familyFee) : calculateAutoAmount({ adultFee, childFee, ...rowCounts });
        if (!row.blockName || !row.flatLabel || !String(row.paidByName || "").trim() || !Number.isFinite(amount) || amount <= 0) return null;
        return cleanObject({ sourceType: "resident", payerType: "resident", communityId: String(communityId || ""), eventId, blockName: String(row.blockName).trim(), floorNumber: extractFloor(row.flatLabel), flatLabel: String(row.flatLabel).trim(), paidByName: String(row.paidByName).trim(), amount, method: String(row.method || "").trim(), receivedByUid: String(row.receivedByUid || "").trim() || undefined, receivedByName: String(row.receivedByName || "").trim() || undefined, amountMode, householdCounts: rowCounts, entryFeeUsed: { adult: adultFee, child: childFee, familyFee, freeBelowAge: freeAge } });
      }).filter(Boolean);

      const series = await getReceiptSeries(eventId);
      for (let start = 0; start < payloads.length; start += 450) {
        const batch = writeBatch(db);
        payloads.slice(start, start + 450).forEach((payload, index) => {
          const sequence = series.highestSequence + start + index + 1;
          batch.set(doc(collection(db, "events", eventId, "funds")), { ...payload, receiptNo: buildReceiptNumber(series.prefix, sequence), receiptPrefix: series.prefix, receiptSequence: sequence, createdAt: serverTimestamp() });
        });
        await batch.commit();
      }
      alert(`Uploaded: ${payloads.length}. Skipped: ${rows.length - payloads.length}.`);
    } catch (error) {
      console.error("Contribution upload error:", error);
      alert(error?.message || "Failed to upload contributions.");
    } finally {
      setUploading(false);
    }
  };

  

  return (
    <div>
        {receiptError && (
  <Alert
    variant="danger"
    dismissible
    onClose={() =>
      setReceiptError("")
    }
  >
    {receiptError}
  </Alert>
)}

      <Row className="g-3">
        <Col md={3}><Form.Label>Block</Form.Label><Form.Select value={form.blockName} onChange={(e) => setForm((p) => ({ ...p, blockName: e.target.value, floorNumber: "", flatLabel: "", residentSelection: "", payerUid: "", paidByName: "" }))}><option value="">Select Block</option>{blockOptions.map((value) => <option key={value} value={value}>{value}</option>)}</Form.Select></Col>
        <Col md={3}><Form.Label>Floor</Form.Label><Form.Select value={form.floorNumber} disabled={!form.blockName} onChange={(e) => setForm((p) => ({ ...p, floorNumber: e.target.value, flatLabel: "", residentSelection: "", payerUid: "", paidByName: "" }))}><option value="">Select Floor</option>{floorOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</Form.Select></Col>
        <Col md={3}><Form.Label>Flat</Form.Label><Form.Select value={form.flatLabel} disabled={form.floorNumber === ""} onChange={(e) => setForm((p) => ({ ...p, flatLabel: e.target.value, residentSelection: "", payerUid: "", paidByName: "" }))}><option value="">Select Flat</option>{flatOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</Form.Select></Col>
        <Col md={3}><Form.Label>Resident Name</Form.Label><Form.Select value={form.residentSelection} disabled={!form.flatLabel} onChange={handleResidentSelectionChange}><option value="">{form.flatLabel ? "Select Resident" : "Select Flat First"}</option>{selectedFlatResidents.map((resident) => <option key={resident.value} value={resident.value}>{resident.name}</option>)}<option value="other">Other Name</option></Form.Select></Col>
      </Row>

      {form.residentSelection === "other" && <Row className="g-3 mt-1"><Col md={4}><Form.Label>Enter Resident Name</Form.Label><Form.Control value={form.paidByName} onChange={(e) => setForm((p) => ({ ...p, payerUid: "", paidByName: e.target.value }))} /></Col></Row>}

      <Card className="mt-3">
  <Card.Body>

    {/* {!isFamilyMode && (
      <> */}
        <Row className="g-3">
          <Col md={4}>
            <Form.Label>Adults</Form.Label>

            <Form.Control
              type="number"
              min="0"
              value={counts.adults}
              onChange={(e) =>
                updateCount(
                  "adults",
                  e.target.value
                )
              }
            />
          </Col>

          <Col md={4}>
            <Form.Label>Kids</Form.Label>

            <Form.Control
              type="number"
              min="0"
              value={counts.kids}
              onChange={(e) =>
                updateCount(
                  "kids",
                  e.target.value
                )
              }
            />
          </Col>

          <Col md={4}>
            <Form.Label>
              Free Kids
              {freeAge != null
                ? ` (below ${freeAge})`
                : ""}
            </Form.Label>

            <Form.Control
              type="number"
              min="0"
              max={counts.kids}
              value={counts.freeKids}
              onChange={(e) =>
                updateCount(
                  "freeKids",
                  e.target.value
                )
              }
            />
          </Col>
        </Row>

        <div className="mt-3">
          Adults: {counts.adults}
          {" | "}
          Kids: {counts.kids}
          {" | "}
          Free Kids: {counts.freeKids}

          <Badge
            bg="primary"
            className="ms-2"
          >
            Total: Rs. {fmt(autoAmount)}
          </Badge>
        </div>
      {/* </>
    )} */}

    {members.length > 0 && (
      <>
        <div className="mt-3">
          <Badge bg="success">
            Total Members: {members.length}
          </Badge>
        </div>

        <Button
          type="button"
          variant="link"
          className="px-0 mt-2"
          onClick={() =>
            setShowFamily(
              (value) => !value
            )
          }
        >
          {showFamily
            ? "Hide"
            : "Show"} Family Details
        </Button>
      </>
    )}

    {showFamily &&
      members.length > 0 && (
        <Table
          bordered
          responsive
          size="sm"
          className="mt-2"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Age</th>
              <th>Relationship</th>
            </tr>
          </thead>

          <tbody>
            {members.map((member) => (
              <tr key={member.id}>
                <td>{member.name}</td>
                <td>
                  {member.age ?? "-"}
                </td>
                <td>
                  {member.relationship}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
  </Card.Body>
</Card>

      {/* <Row className="g-3 mt-1">
        <Col md={3}><Form.Label>Amount Mode</Form.Label><div><Form.Check inline type="radio" name="contributionMode" label="Auto" disabled={isFamilyMode} checked={form.amountMode === "auto"} onChange={() => setForm((p) => ({ ...p, amountMode: "auto" }))} /><Form.Check inline type="radio" name="contributionMode" label="Manual" checked={form.amountMode === "manual"} onChange={() => setForm((p) => ({ ...p, amountMode: "manual" }))} /></div></Col>
        <Col md={3}><Form.Label>Amount</Form.Label><Form.Control type="number" min="0" value={form.amount} disabled={form.amountMode === "auto" && !isFamilyMode} onChange={(e) => setForm((p) => ({ ...p, amount: e.target.value }))} /></Col>
        <Col md={3}><Form.Label>Pay Mode</Form.Label><Form.Select value={form.method} onChange={(e) => setForm((p) => ({ ...p, method: e.target.value }))}><option value="">Select Pay Mode</option>{PAYMENT_METHODS.map((method) => <option key={method} value={method}>{method}</option>)}</Form.Select></Col>
        <Col md={3}><Form.Label>Received By</Form.Label><Form.Select value={form.receivedByUid ? `uid:${form.receivedByUid}` : form.receivedByName ? `name:${form.receivedByName}` : ""} onChange={(e) => { const option = committeeOptions.find((item) => item.value === e.target.value); setForm((p) => ({ ...p, receivedByUid: option?.uid || "", receivedByName: option?.label || "" })); }}><option value="">Select Committee Member</option>{committeeOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</Form.Select></Col>
      </Row> */}

      <Row className="g-3 mt-1">
  <Col md={3}>
    <Form.Label>
      Amount Mode
    </Form.Label>

    <div>
      <Form.Check
        inline
        type="radio"
        name="contributionMode"
        label="Auto"
        disabled={isFamilyMode}
        checked={
          form.amountMode === "auto"
        }
        onChange={() =>
          setForm((previous) => ({
            ...previous,
            amountMode: "auto",
          }))
        }
      />

      <Form.Check
        inline
        type="radio"
        name="contributionMode"
        label="Manual"
        checked={
          form.amountMode ===
          "manual"
        }
        onChange={() =>
          setForm((previous) => ({
            ...previous,
            amountMode: "manual",
          }))
        }
      />
    </div>
  </Col>

  <Col md={3}>
    <Form.Label>
      Receipt No
    </Form.Label>

    <div className="position-relative">
      <Form.Control
        type="text"
        value={
          form.receiptNo || ""
        }
        readOnly
        className="bg-light"
        placeholder={
          loadingReceiptNumber
            ? "Loading receipt number..."
            : "Receipt number unavailable"
        }
      />

      {loadingReceiptNumber && (
        <Spinner
          animation="border"
          size="sm"
          className="position-absolute top-50 end-0 translate-middle-y me-2"
        />
      )}
    </div>

    <Form.Text className="text-muted">
      Final number is checked again
      when saving.
    </Form.Text>
  </Col>

  <Col md={2}>
    <Form.Label>
      Amount
    </Form.Label>

    <Form.Control
      type="number"
      min="0"
      value={form.amount}
      disabled={
        form.amountMode === "auto" &&
        !isFamilyMode
      }
      onChange={(eventValue) =>
        setForm((previous) => ({
          ...previous,
          amount:
            eventValue.target.value,
        }))
      }
    />
  </Col>

  <Col md={2}>
    <Form.Label>
      Pay Mode
    </Form.Label>

    <Form.Select
      value={form.method}
      onChange={(eventValue) =>
        setForm((previous) => ({
          ...previous,
          method:
            eventValue.target.value,
        }))
      }
    >
      <option value="">
        Select Pay Mode
      </option>

      {PAYMENT_METHODS.map(
        (method) => (
          <option
            key={method}
            value={method}
          >
            {method}
          </option>
        )
      )}
    </Form.Select>
  </Col>

  <Col md={2}>
    <Form.Label>
      Received By
    </Form.Label>

    <Form.Select
      value={
        form.receivedByUid
          ? `uid:${form.receivedByUid}`
          : form.receivedByName
            ? `name:${form.receivedByName}`
            : ""
      }
      onChange={(eventValue) => {
        const selectedOption =
          committeeOptions.find(
            (option) =>
              option.value ===
              eventValue.target.value
          );

        setForm((previous) => ({
          ...previous,

          receivedByUid:
            selectedOption?.uid || "",

          receivedByName:
            selectedOption?.label ||
            "",
        }));
      }}
    >
      <option value="">
        Select Committee Member
      </option>

      {committeeOptions.map(
        (option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        )
      )}
    </Form.Select>
  </Col>
</Row>

      <div className="d-flex flex-wrap gap-2 mt-4">
        <Button type="button" onClick={save} disabled={saving || uploading || loadingReceiptNumber || !form.receiptNo}>{saving ? <><Spinner size="sm" className="me-2" />Saving...</> : "Add Contribution"}</Button>
        <Button type="button" variant="outline-secondary" onClick={downloadTemplate} disabled={saving || uploading}>Download Template</Button>
        <Form.Label className={`btn btn-outline-success mb-0 ${uploading || saving ? "disabled" : ""}`}>{uploading ? "Uploading..." : "Upload Excel"}<Form.Control hidden type="file" accept=".xlsx,.xls" disabled={uploading || saving} onChange={async (e) => { await uploadTemplate(e.target.files?.[0]); e.target.value = ""; }} /></Form.Label>
      </div>
    </div>
  );
}
